import styled from 'styled-components';
import FlexBox from '@app/components/atoms/FlexBox';
import { Text } from '@app/components/atoms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';

export const Container = styled(FlexBox)`
  position: relative;
  width: 100%;

  margin: 0 auto 50px;
  padding-top: 10px;
  box-sizing: border-box;
  background: linear-gradient(
      215deg,
      rgba(20, 184, 166, 0.15) 0%,
      rgba(21, 185, 167, 0.2) 50%,
      rgba(153, 246, 228, 0.25) 100%
    ),
    radial-gradient(
      116.07% 138.07% at 0% 0%,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(20, 184, 166, 0.2) 45%,
      rgba(153, 246, 228, 0.15) 100%
    ),
    radial-gradient(
      114.04% 135.94% at 98.93% 1.4%,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(20, 184, 166, 0.2) 45%,
      rgba(153, 246, 228, 0.15) 100%
    );

  @media screen and (min-width: 1450px) {
    width: 100%;
  }

  @media screen and (max-width: 1500px) {
    margin: 0px;
    padding: 0px;
  }

  @media screen and (max-width: 975px) {
  }
`;

export const Wrapper = styled(FlexBox)`
  align-items: center;
  margin: 0 auto;
  max-width: 1500px;

  @media screen and (max-width: 975px) {
    max-width: 90%;
  }

  @media screen and (max-width: 500px) {
    max-width: unset;
  }
`;

export const Title = styled(Text)`
  font-size: 60px;
  font-weight: 700;
  line-height: 70px;
  text-align: center;
  max-width: 1000px;
  margin: 150px 0 100px;

  span {
    color: #2faf92;
  }

  @media screen and (max-width: 950px) {
    width: 100%;
    font-size: 40px;
    line-height: 43px;
  }
`;

export const Subtitle = styled(Text)`
  font-weight: 600;
  margin-bottom: 26px;
  text-align: center;

  span {
    color: #d47e5b;
    cursor: pointer;
  }
`;

export const TrustedSection = styled.section`
  padding: 0;
  text-align: center;
  width: 100%;
  margin-top: 50px;
`;

export const TrustedTitle = styled.h2`
  font-family: 'Source Serif 4', serif;
  font-size: 32px;
  color: #4f4f4f;
  margin-bottom: 40px;
  font-weight: 400;
`;

export const BrokerageRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  margin: 0 auto;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  background-color: #fff;
`;

export const BrokerageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  max-width: 1100px;
  margin: 0 auto;

  > div {
    padding: 40px 60px 40px 0;
    display: flex;
    align-items: center;

    &:not(:last-child) {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: -1px;
        bottom: -1px;
        width: 1px;
        background-color: #e5e5e5;
      }
    }

    &:last-child {
      padding-right: 0;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 20px;
    padding: 0;

    > div {
      padding: 10px 20px 10px 0;

      &:not(:last-child):after {
        display: none;
      }
    }
  }

  img {
    height: 80px !important;
    width: auto;
    max-height: 80px;
    object-fit: contain;
    opacity: 0.8;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }

    @media (max-width: 768px) {
      height: 60px !important;
      max-height: 60px;
    }
  }
`;

export const BrokerageLogos = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 20px;
  }

  img {
    width: auto;
    opacity: 0.8;
    transition: opacity 0.2s ease;
    height: 100px;

    &:hover {
      opacity: 1;
    }
  }
`;
